export default __webpack_public_path__ + "static/media/processorIcon.4337e2e5.svg";